import apiRequest from './client';

// tirage = code catalogue (ex: 1 pour NY MIDI), date au format YYYY-MM-DD.
// numbers = "NUMBER" (2-3 chiffres), win4 = "WIN4" (4 chiffres) — cf. WinningNumbersPage.jsx.
// Cote company : cree un override scope sur la company connectee (ne remonte pas sur
// les autres companies).
export const submitWinningNumber = ({ tirage, date, numbers, win4 }) =>
  apiRequest('/tirages/winning-numbers/', { method: 'POST', body: { tirage, date, numbers, win4 } });

// Cote superadmin : ecrit la valeur GLOBALE (toutes companies) et efface les
// overrides par-company du meme tirage/date. Auth session Django (is_staff).
export const submitSuperadminWinningNumber = ({ tirage, date, numbers, win4 }) =>
  apiRequest('/tirages/winning-numbers/superadmin/', { method: 'POST', body: { tirage, date, numbers, win4 } });

// Lien "Check Source" : va lire le resultat sur lotomobil sans rien ecrire, pour
// preremplir le formulaire. Renvoie { numbers, win4, time, tirage_name } ou leve
// une erreur (404) si la source n'a pas encore le resultat.
export const peekWinningNumber = ({ tirage, date }) =>
  apiRequest(`/tirages/winning-numbers/peek/?tirage=${encodeURIComponent(tirage)}&date=${encodeURIComponent(date)}`);

// Source lotomobil (site + API) d'ou le scraper lit les lots gagnants de ce tirage.
// -> { lottery_id, lottery_name, site_url, api_url }. 404 si tirage non gere.
export const fetchWinningNumberSource = ({ tirage }) =>
  apiRequest(`/tirages/winning-numbers/source/?tirage=${encodeURIComponent(tirage)}`);

// Tableau des lots gagnants deja saisis a une date : par tirage, le numero gagnant
// + le nombre de fiches gagnantes de la company + la somme totale gagnee.
// Renvoie { date, rows: [...], grand_total, grand_tickets }.
export const fetchWinningNumberSummary = ({ date }) =>
  apiRequest(`/tirages/winning-numbers/summary/?date=${encodeURIComponent(date)}`);

// Version superadmin : valeur GLOBALE par tirage + nb d'overrides company + fiches
// gagnantes / somme totale AGREGEES sur toutes les companies.
export const fetchSuperadminWinningNumberSummary = ({ date }) =>
  apiRequest(`/tirages/winning-numbers/superadmin/summary/?date=${encodeURIComponent(date)}`);

// Rapports > Winning Numbers (2026-10-12) : numeros gagnants applicables a la
// company sur une periode [dateFrom, dateTo], loterie optionnelle ('0' = toutes).
export const fetchWinningNumberReport = ({ dateFrom, dateTo, tirage }) => {
  const qs = new URLSearchParams({ date_from: dateFrom, date_to: dateTo });
  if (tirage && tirage !== '0') qs.append('tirage', tirage);
  return apiRequest(`/tirages/winning-numbers/report/?${qs.toString()}`);
};
